<script setup>
definePage({
  path: '/setup/emails/themes/edit/:guid/:templateGUID?',
  meta: { ...PageMeta.Themes.Edit.Meta, pageTitle: PageMeta.Themes.Edit.Title },
})

import HorizontalThemesMenu from '@/components/Menus/Themes/HorizontalThemesMenu.vue'
import ThemeEditPage from '@/views/setup/emails/themes/edit/ThemeEditPage.vue'

const route = useRoute()

/* ** */
</script>

<template>
  <section>
    <!-- Horizontal Menu / Navigation -->
    <VRow>
      <VCol cols="12">
        <HorizontalThemesMenu :theme-g-u-i-d="route.params.guid" />
      </VCol>
    </VRow>

    <!-- Page -->
    <VRow>
      <VCol cols="12">
        <ThemeEditPage
          v-if="route.params.guid"
          :key="route.params.guid"
          :theme-g-u-i-d="route.params.guid"
          :template-g-u-i-d="route.params.templateGUID"
        />
      </VCol>
    </VRow>
  </section>
</template>
